import classNames from 'classnames'

export const TextArea = (props: any) => {
  const { error, inputRef, isCheck, userCheck, bg, disabled, onInput } = props

  const inputClass = classNames(
    'w-[343px] text-base md:w-full    rounded-[10px] p-[16px] ',
    {
      'border border-error focus:outline-none': error,
      'border-[#D9DEE8]': !error,
      'opacity-[0.5]': isCheck,
      'bg-[#F6F8FB]': !bg,
      'bg-white': bg,
    }
  )
  return (
    <textarea
      {...props}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault() // 그냥 Enter는 submit 방지
        }
      }}
      rows={3}
      className={inputClass}
      ref={inputRef}
      onClick={userCheck}
      disabled={disabled}
      onInput={onInput}
    />
  )
}

export const TextAreaMyVideo = (props: any) => {
  const { error, inputRef, isCheck, userCheck, className } = props

  const inputClass = classNames(
    `w-[290px]  text-base md:w-full  h-[123px]  rounded-[10px] p-[16px] bg-[#F6F8FB] ${className}`,
    {
      'border border-error focus:outline-none': error,
      'border-[#D9DEE8]': !error,
      'opacity-[0.5]': isCheck,
    }
  )
  return (
    <textarea
      {...props}
      className={inputClass}
      ref={inputRef}
      onClick={userCheck}
    />
  )
}

export const TextAreaContent = (props: any) => {
  const { error, inputRef, isCheck, userCheck, className, maxLength } = props

  const inputClass = classNames(
    `w-[736px]  text-base md:w-full  h-[93px]  border-[1px] rounded-[10px] p-[16px] bg-[#F6F8FB] ${className} bg-white`,
    {
      'border border-error focus:outline-none': error,
      'border-[#D9DEE8]': !error,
      'opacity-[0.5]': isCheck,
    }
  )
  return (
    <textarea
      {...props}
      className={inputClass}
      ref={inputRef}
      onClick={userCheck}
      maxLength={maxLength ?? 10000}
    />
  )
}
